import { REFRESH_ORDERHISTORY } from '../actions'

export default function (state = '', action) {
    switch (action.type) {
        case REFRESH_ORDERHISTORY:
            return action.payload
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/loadingorderhistory_reducer.js